module.exports = __webpack_public_path__ + "static/media/translation.7b00505f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/translation.svg
// module id = 455
// module chunks = 0